import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
    return (
        <div className='min-h-[80vh] px-4 py-6 sm:px-6 lg:px-8 sm:py-8 lg:py-10 text-gray-800 dark:text-gray-200'>
            <div className='max-w-7xl mx-auto p-4 sm:p-6 md:p-8'>
                <Link to="/" className='inline-block mb-4 sm:mb-6'>
                    <h1 className='text-indigo-500 font-bold text-2xl sm:text-3xl md:text-4xl logo-font'>Hazrat Ali</h1>
                </Link>
                
                <h1 className='text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6'>Terms & Conditions</h1>
                
                <div className='space-y-4 sm:space-y-6 text-sm sm:text-base leading-relaxed'>
                    <p className='text-base sm:text-lg font-semibold'>Last updated: April 15, 2024</p>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>1. Introduction</h2>
                        <p>Welcome to Hazrat Ali Portfolio. By accessing and using this website, you accept and agree to be bound by the terms and conditions outlined here.</p>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>2. Website Usage Terms</h2>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Content is provided for educational purposes only</li>
                            <li>Users must be at least 13 years old to access the website</li>
                            <li>Users are responsible for maintaining account security</li>
                            <li>Prohibited activities will result in account termination</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>3. Content Ownership & Copyright</h2>
                        <p>All content published on Hazrat Ali Portfolio is protected by copyright law. Users may not reproduce, distribute, or create derivative works without explicit permission.</p>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>4. User Registration & Account Terms</h2>
                        <p>Users must provide accurate information when creating an account. Accounts found to contain false information may be terminated without notice.</p>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>5. Code Snippet Usage Policy</h2>
                        <p>Code snippets provided on Hazrat Ali Portfolio are available for educational purposes. Users may use these snippets in their projects with proper attribution.</p>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>6. Comment Policy & Community Guidelines</h2>
                        <ul className='list-disc pl-5 sm:pl-6 mt-2 space-y-1'>
                            <li>Be respectful and constructive in discussions</li>
                            <li>No spam, harassment, or offensive content</li>
                            <li>Stay on topic and contribute meaningfully</li>
                            <li>Moderators may remove inappropriate content</li>
                        </ul>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>7. Limitation of Liability</h2>
                        <p>Hazrat Ali Portfolio is not liable for any damages arising from the use or inability to use our website or services.</p>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>8. Changes to Terms</h2>
                        <p>We reserve the right to modify these terms at any time. Users will be notified of significant changes via email or website announcement.</p>
                    </section>
                    
                    <section>
                        <h2 className='text-lg sm:text-xl font-bold mb-2 mt-3 sm:mt-4'>9. Contact Information</h2>
                        <p>For questions about these terms, please contact us at <a href="mailto:hazrataliein@gmail.com" className='text-indigo-500 hover:underline'>hazrataliein@gmail.com</a></p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Terms;